<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <p>&copy; 2018 My Resume Format - Resume Builder
      </div>
      <div class="col-md-6 text-right">
        <ul class="list-inline">
          <li class="list-inline-item"><a href="https://www.myresumeformat.com/about/">About Us</a></li>
          <li class="list-inline-item"><a href="https://www.myresumeformat.com/blog/">Blog</a></li>
          <!--<li class="list-inline-item"><a href="/login/pricing">Pricing</a></li>-->
          <li class="list-inline-item"><a href="https://www.myresumeformat.com/faq/">FAQ</a></li>
          <li class="list-inline-item"><a href="https://www.myresumeformat.com/terms-conditions/">Terms &amp; Conditions</a></li>
          <li class="list-inline-item"><a href="https://www.myresumeformat.com/contact-us/">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
